

import { request } from "@/network/request.js";

export function fn_overload(num) {
	if (typeof (num) != 'number') {
		num = num * 1
	}
	if (num > 999) {     //字数是否过千
		var sen = num / 1000;    //过千处理
		var vals = sen.toFixed(1)    //保留一位小数
		return vals + "k"      //字符串拼接
	} else {
		return num
	}
}

// ==================================
// 分享内容列表
// content_type	否	string	//1:名片2:文章3:产品4:表单5:素材 逗号间隔
// search_name	否	string	名称
// search_time	否	json	搜索时间
// member_id	否	string	成员id 逗号间隔
// is_poster	否	int	//0:链接1:海报 全部就不传
// pagesize	是	int	每页数量
// sort_type	是	int	//1:浏览时间2:浏览量3:线索量4:转化量
export function get_share_content_report_list(params) {
	return request({
		url: '/hkt/cutomerkanban/get_share_content_report_list',
		params,
	})
}
// 浏览记录列表
// content_type	否	string	//1:名片2:文章3:产品4:表单5:素材 逗号间隔
// search_name	否	string	名称
// search_time	否	json	搜索时间
// member_id	否	string	成员id 逗号间隔
// pagesize	是	int	每页数量
// sort_type	是	int	1:浏览时间2:浏览时长3:浏览次数
export function get_visit_record_report_list(params) {
	return request({
		url: '/hkt/cutomerkanban/get_visit_record_report_list',
		params,
	})
}

// 转发记录列表
// content_type	否	string	//1:名片2:文章3:产品4:表单5:素材 逗号间隔
// search_name	否	string	名称
// search_time	否	json	搜索时间
// member_id	否	string	成员id 逗号间隔
// pagesize	是	int	每页数量
// sort_type	是	int	//1:转发时间
export function get_forward_record_report_list(params) {
	return request({
		url: '/hkt/cutomerkanban/get_forward_record_report_list',
		params,
	})
}
// 详情数据
// content_type	是	int	//1:名片2:文章3:产品4:表单5:素材
// content_id	是	int	内容id
// member_id	是	int	成员id
export function get_report_data(params) {
	return request({
		url: '/hkt/cutomerkanban/get_report_data',
		params,
	})
}
// 详情列表
// content_type	是	int	//1:名片2:文章3:产品4:表单5:素材
// content_id	是	int	内容id
// member_id	是	int	成员id
// pagesize	是	int	每页数量
export function get_report_details(params) {
	return request({
		url: '/hkt/cutomerkanban/get_report_details',
		params,
	})
}
// 成员记录列表
// content_type	否	string	//1:名片2:文章3:产品4:表单5:素材 逗号间隔
// department_id	否	string	部门id 逗号间隔
// search_time	否	json	搜索时间
// member_id	否	string	成员id 逗号间隔
// pagesize	是	int	每页数量
// sort_type	是	int	//1:浏览数量2:分享数量3:转化量
export function get_share_content_member_list(params) {
	return request({
		url: '/hkt/cutomerkanban/get_share_content_member_list',
		params,
	})
}
// 成员数据
// member_id	否	int	成员id
export function get_member_data(params) {
	return request({
		url: '/hkt/cutomerkanban/get_member_data',
		params,
	})
}

export function randomArr(min, max) {
	if (min && max) {
		return Math.round(Math.random() * (max - min)) + min;
	}
}
export function JsonStr(obj) {
	if (obj) {
		return JSON.parse(JSON.stringify(obj))
	}
}


// 获取主管部门
export function get_admin_department() {
	return request({
		url: '/hkt/department/get_admin_department',
		params: {}
	})
}

// 获取成员列表
// pagesize	是	int	页码
// user_name	否	string	账号
// role_id	否	int	角色id
// department_id	否	int	部门id
export function get_member_detailed_list(params) {
	return request({
		url: '/hkt/member/get_member_detailed_list',
		params,
	})
}
// ----------------------------------------------------------------

export function fn_headledepartmen(obj) {
	let newArr = []
	let ele_ = {
		id: obj.department_id,
		name: obj.name
	}
	if (obj.son) {
		for (let item1 of obj.son) {
			if (item1.department_id) {
				let ele1 = {
					id: item1.department_id,
					name: item1.name
				}
				newArr.push(ele1)
				if (item1.son && item1.son.length) {
					for (let item2 of item1.son) {
						let ele2 = {
							id: item2.department_id,
							name: item2.name
						}
						newArr.push(ele2)
						if (item2.son && item2.son.length) {
							for (let item3 of item2.son) {
								let ele3 = {
									id: item3.department_id,
									name: item3.name
								}
								newArr.push(ele3)
								if (item3.son && item3.son.length) {
									for (let item4 of item3.son) {
										let ele4 = {
											id: item4.department_id,
											name: item4.name
										}
										newArr.push(ele4)
									}
								}
							}
						}
					}
				}
			}
		}
	}

	return newArr
}

export function getCurrentfield(flag) {
	var date = new Date(),
		year = date.getFullYear(),
		month = date.getMonth() + 1,
		day = date.getDate(),
		hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
		minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
		second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
	month >= 1 && month <= 9 ? (month = "0" + month) : "";
	day >= 0 && day <= 9 ? (day = "0" + day) : "";
	return `${year}${month}${day}${hour}${minute}${second}`
};

// 导出表格
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export function exportExcel(eleid, fname) {
	if (eleid && typeof (eleid) == 'string') {
		/* generate workbook object from table */
		var xlsxParam = {
			raw: true
		} // 导出的内容只做解析，不进行格式转换
		var table = document.querySelector(eleid).cloneNode(true)
		if (table) {
			let elfixed = table.querySelector('.el-table__fixed')
			if (elfixed) {
				table.removeChild(table.querySelector('.el-table__fixed')) //这里是双下划线
			}
			var wb = XLSX.utils.table_to_book(table, xlsxParam)
			/* get binary string as output */
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			})
			try {
				let fileName = `${fname || '获客通表格'}-${getCurrentfield()}.xlsx`
				FileSaver.saveAs(new Blob([wbout], {
					type: 'application/octet-stream'
				}), fileName)
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout)
				}
			}
			return wbout
		}
	}
}


export function get_record(item) {
	if (item) {
		if (item.card_id) {
			item.icon = '/latest1-1.png'
			item.portrait = item.head_image ? item.head_image : '';
		}
		else if (item.article_id) {
			item.icon = '/latest1-2.png'
			item.portrait = item.article_image ? item.article_image : '';
		}
		else if (item.goods_id) {
			item.icon = '/latest1-3.png'
			item.portrait = item.goods_image ? item.goods_image : '';
		}
		else if (item.form_id) {
			item.icon = '/latest1-4.png'
		}
		else if (item.mat_id) {
			if (item.file_type > 0) { // 文件图标，文件类型
				item.icon = `/mat1-${item.file_type}.png`
			} else {
				item.portrait = item.file_url = item.file_url ? item.file_url : '';
			}
		}
		// 怎么进来的
		item.getType = item.is_poster ? '海报分享' : '链接分享';
	}
}

export function getSecondTime(time) {
	if (time && typeof (time) == 'number') {
		// 转换为式分秒
		let h = parseInt(time / 60 / 60 % 24)
		let m = parseInt(time / 60 % 60)
		let s = parseInt(time % 60)
		h = h > 9 ? h : '0' + h;
		m = m > 9 ? m : '0' + m;
		s = s > 9 ? s : '0' + s;
		// 作为返回值返回
		let t = `${h || '00'}:${m || '00'}:${s || '00'}`
		return t
	}
	else {
		return '--'
	}
}

export function handle_detail(row) {
	//1:名片2:文章3:产品4:表单5:素材
	if (row) {
		let content_type = 1
		if (row.article_id) {
			content_type = 2
		} else if (row.goods_id) {
			content_type = 3
		} else if (row.form_id) {
			content_type = 4
		} else if (row.mat_id) {
			content_type = 5
		}
		let content_id = row.article_id || row.card_id || row.form_id || row.goods_id || row.mat_id || row.content_id;
		return {
			content_type,
			content_id,
			member_id: row.member_id,
		}
	}
	else {
		return ''
	}
}